import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { RootState } from "../index";
import { API_BASE_URL } from "../../constants";

export interface deviceTemp {
  timestamp: string;
  temp: number;
}
export interface externalTemp {
  timestamp: string;
  temp: number;
}
export interface deviceVoltage {
  timestamp: string;
  voltage: number;
}

export interface deviceLteLink {
  timestamp: string;
  rsrp: number;
}

export interface Device {
  id?: number;
  deviceId: string;
  location: string;
  phoneNumber?: string;
  smsTemplate?: string;
  alarmPhoneNumber: string;
  internalTemp?: deviceTemp;
  externalTemp?: externalTemp;
  batteryVoltage?: deviceVoltage;
  ltelink?: deviceLteLink;
}

const devicesApi = createApi({
  reducerPath: "devices",
  baseQuery: fetchBaseQuery({
    baseUrl: `${API_BASE_URL}/devices`,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).auth.token;
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
    },
  }),
  tagTypes: ["loadDevices"],
  endpoints(builder) {
    return {
      loadAllDevices: builder.query<Device[], null>({
        providesTags: (users) => ["loadDevices"],
        query: () => {
          return {
            url: "/",
            method: "GET",
          };
        },
      }),
      deleteDevice: builder.mutation<Device, number>({
        invalidatesTags: ["loadDevices"],
        query: (id) => {
          return {
            url: `/${id}`,
            method: "DELETE",
          };
        },
      }),
      addDevice: builder.mutation<Device, Device>({
        invalidatesTags: ["loadDevices"],
        query: (newDevice) => {
          return {
            url: "/",
            method: "POST",
            body: newDevice,
          };
        },
      }),
      modifyDevice: builder.mutation<Device, Device>({
        invalidatesTags: ["loadDevices"],
        query: (device) => {
          return {
            url: `/${device.id}`,
            method: "PATCH",
            body: device,
          };
        },
      }),
    };
  },
});

export const {
  useLoadAllDevicesQuery,
  useDeleteDeviceMutation,
  useAddDeviceMutation,
  useModifyDeviceMutation,
} = devicesApi;
export { devicesApi };
